/* Dansk katalog for locale-investment-resolution.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'investments.documentNonPostingResolved': 'Afklaret som kontroloplysning',
  'investments.documentExistingEventResolved': 'Koblet til registreret hændelse',
  'investments.resolutionTitle': 'Afklar dokumentlinjen',
  'investments.resolutionIntro': 'Vælg kun en afslutning, når originaldokumentet og investeringsregistret dokumenterer, hvad linjen repræsenterer. Afklaringen laver ingen postering.',
  'investments.resolutionChoice': 'Hvad repræsenterer linjen?',
  'investments.resolutionType.non_posting_reference': 'Kontrol- eller sammenligningsoplysning – ingen selvstændig transaktion',
  'investments.resolutionType.existing_event': 'Allerede registreret som en anden investeringshændelse',
  'investments.resolutionExistingEvent': 'Registreret hændelse',
  'investments.resolutionNote': 'Kontrolnotat og dokumenteret begrundelse',
  'investments.resolutionNoPostingWarning': 'Dette afslutter linjen uden postering. Brug kun valget, når kilden viser, at beløbet er kontrolinformation og ikke en selvstændig økonomisk hændelse.',
  'investments.resolutionUnsupportedHelp': 'Udlodning i form af fondsandele og andre hændelser, der ændrer antal eller kostpris uden kontant afregning, understøttes ikke af denne afklaring. Lad linjen stå åben, indtil hændelsen kan behandles særskilt.',
  'investments.resolutionSave': 'Gem afklaring',
  'investments.resolutionSaved': 'Dokumenteret afklaring',
  'investments.resolutionLinkedEvent': 'Koblet hændelse',
  'investments.resolutionReopenNote': 'Begrundelse for ny gennemgang',
  'investments.resolutionReopen': 'Åbn afklaringen igen',
});
